import { render, staticRenderFns } from "./FlagSpain.vue?vue&type=template&id=6fde2485&"
import script from "./FlagSpain.vue?vue&type=script&lang=js&"
export * from "./FlagSpain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports